


























import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { UnifiedInsightsReportsStoreState } from './unified-insights-reports.store';
import { namespace } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';

const cssPrefix = 'delivery-filter';
const reportStoreModule = namespace('UnifiedInsightsReportsStoreModule');

interface FilterOptions {
  label: string;
  id: string;
  statusFlag?: string;
  valueKey: string;
}

@Component({
  components: { SwCheckbox },
})
export default class DeliveryFilter extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @reportStoreModule.Mutation
  saveToFilters: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['filterData']
  >;

  @reportStoreModule.State
  filterData: UnifiedInsightsReportsStoreState['filterData'];

  optionsSelected: string[] = [];

  deliveryOptions: FilterOptions[] = [
    {
      label: this.$t('spog.unifiedInsights.archive')
      .toString(),
      id: 'Archive',
      statusFlag: 'archive',
      valueKey: 'archive',
    },
    {
      label:  this.$t('home.download')
      .toString(),
      id: 'Download',
      statusFlag: 'download',
      valueKey: 'download',
    },
    {
      label: this.$t('common.email')
      .toString(),
      id: 'Email',
      statusFlag: 'email',
      valueKey: 'email',
    },
  ];

  /*
    @desc returns selected options for Report Status filter.
  */

  get deliveryMethodFilter() {
    return this.filterData ? this.filterData.deliveryMethod : [];
  }

  @Watch('deliveryMethodFilter')
  onPropertyChanged(value: string[]) {
    this.optionsSelected = value;
  }

  /*
    @desc updates selected checkbox options.
  */

  updateSelected(event: any) {
    this.optionsSelected = event;
    const obj: any = {
      deliveryMethod: this.optionsSelected,
    };
    this.saveToFilters(obj);
  }

  created() {
    this.optionsSelected = this.deliveryMethodFilter;
  }
}
